<template>
	<div id="redRain">
		<img v-for="(n,index) in rainlist" class="rainImg" :src="imgPath+'home/redbagrain.png'" v-show="index > rainIndex" :style="n" :key="index" @click="getRainRed">

		<van-popup v-model="redrain1">
			<div id='redrainfails'>
				<img :src="imgPath+'home/redrainno.png'" />
				<p>空空如也，再接再厉</p>
			</div>
			<img @click="redrain1OO" :src="imgPath+'close.png'" class="close">
		</van-popup>

		<van-popup v-model="redrain2">
			<div id='redrainSuccess'>
				<div class="title">恭喜您，成功抢到</div>
				<p class="money">{{rainmoney/100}}<span>元</span></p>
				<p class="mannum"><span>{{mannum}}</span>人已抢到。</p>
				<img @click="redrain2OO" :src="imgPath+'close.png'" class="close">
			</div>
		</van-popup>
	</div>
</template>

<script>
import Vue from 'vue';
import tool from '../../kits/Tools.js';

export default {
	data() {
		return {
			imgPath:'',
			rainlist: [],
			rainIndex: -20,
			redrain1: false,
			redrain2: false,
			rainmoney: 0,
			mannum: 0,
		}
	},
	props:['rainProbab','rainId','fans_id'],
	mounted() {
		this.imgPath = tool.imgPath();
	},
	methods: {
		redbagRain(json) { //下红包雨
			var that = this;
			console.log('rainProbab'+this.rainProbab+'rainId'+this.rainId)
			if(json) {
				if(json.module == "red_rain_close") {
					clearInterval(this.timer3);
					return false;
				}
			}

			function add() {
				var width = parseInt(Math.random() * 40 + 20);
				var Left = parseInt(Math.random() * 60 + 10);
				var rot = (parseInt(Math.random() * 90 - 45)) + "deg";
				var style = {
					"left": Left + '%',
					"width": width + 'px',
					"transform": "rotate(" + rot + ")"
				}
				that.rainlist.push(style);
				setTimeout(function() {
					that.rainIndex++;
				}, 15000)
			};
			this.timer3 = setInterval(add, 500);
		},
		getRainRed() {
			var that = this;
			let Base64 = require('js-base64').Base64;
			if((100 * Math.random()) <= Number(this.rainProbab)) {

				this.axios.post(tool.baseUrl3() + "/redrain/index",'fans_id='+ this.fans_id + '&msg_id='+this.rainId).then(function(data) {
					var data = data.data;
					console.log("抢到的红包数据:" + JSON.stringify(data));
					if(data.code == 200) {
						if(data.data.amount == 0 || data.data.amount == '0') {
							that.redrain1OO();
						} else {
							that.redrain2OO();
							that.rainmoney = data.data.amount;
							that.mannum = data.data.count;
						}
					}
				}).catch(function(data) {
					console.log(data);
				})
			} else {
				that.redrain1OO();
			}
		},
		redrain1OO() {
			this.redrain1 = !this.redrain1;
		},
		redrain2OO() {
			this.redrain2 = !this.redrain2;
		},
	}
}
</script>

<style scoped>
.rainImg {
	position: fixed;
	display: block;
	z-index: 2000;
	top: -100px;
	animation: rain 5s ease-in;
}

@keyframes rain {
	0% {
		top: -100px;
	}
	100% {
		top: 120%;
	}
}
	
#redrainfails {
	text-align: center;
	font-size: 16px;
	color: #666;
	padding: 10px 0;
}

#redrainfails img {
	width: 100px;
}

#redrainSuccess {
	margin: -10px;
	background: #fff;
	text-align: center;
}

#redrainSuccess .title {
	background-color: #e9251e;
	padding: 15px;
	color: #fff;
}

#redrainSuccess .money {
	padding: 28px;
	font-family: Impact;
	font-size: 29px;
	color: #393939;
}

#redrainSuccess .mannum {
	color: #696969;
	padding-bottom: 30px;
}

#redrainSuccess .mannum span {
	color: #e9251e;
}
</style>